import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    BymoPagePropsSpecialContentSettingMetadata,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';
import type {LocationCoordinates} from '@wix/devzai-utils-common';

export namespace DoppeActionTypeNavigateMapButton {

    export interface ActionSettings {
        /**
         * The precise location coordinates for navigation.
         * When present, navigation URL uses lat/lon for accuracy.
         */
        locationCoordinates: LocationCoordinates | null;
        
        /**
         * Display address shown in UI and used as fallback when coordinates are null.
         */
        displayAddress: string;
        
        /**
         * Whether to show the contact panel when clicking the button.
         */
        showContactPanel: boolean;
    }
}

export const doppeActionTypeNavigateMapButton = doppeActionTypeDefineMetadata<DoppeActionTypeNavigateMapButton.ActionSettings>({
    id: 'io.bymo.action/navigate-map-button',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        locationCoordinates: null,
        displayAddress: '',
        showContactPanel: false,
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            displayAddress: bymoPagePropsCreateContentSettingMetadata(
                BymoPagePropsContentSettingType.Text, 
                BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified
            ),
            locationCoordinates: BymoPagePropsSpecialContentSettingMetadata.ToBeConsidered,
            showContactPanel: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Boolean, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified, {description: 'field.showContactPanel'}),
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {},
        bindableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
});
